/**
 * @module ui/financial-search
 */
import { isMobile } from "utils/detect";
import { qsa } from "utils/utils";
import ee from "lib/eventemitter";

/**
 * @method init
 * @description Initialize form submit and event tracking handlers
 */
export default function init() {
  const forms = qsa(".js-financial-search");
  forms.forEach(formRoot => {
    if (!formRoot.dataset) {
      return;
    }
    // change the form action url based on the viewport tier
    formRoot.addEventListener("submit", function onSubmit(e) {
      // fallback to default form action value, since these are optional custom fields
      const actionMobile = formRoot.dataset.actionMobile ? formRoot.dataset.actionMobile : formRoot.action;
      const actionDesktop = formRoot.dataset.actionDesktop ? formRoot.dataset.actionDesktop : formRoot.action;
      // use mobile action when viewport is mobile width
      let url = isMobile() ? actionMobile : actionDesktop;
      url = url.replace("{query}", encodeURIComponent(formRoot.elements.q.value));

      // track the submit event
      ee.trigger("analytics.trackGTMEvent", [{
        feature: "financial-search-widget",
        type: "button",
        action: formRoot.elements.q.attributes.placeholder.value,
        label: formRoot.elements.q.value
      }, "clickEvent", () => {
        // url may contain #hash, so we need to update the location instead of submitting the form
        window.location.href = url;
      }]);

      // prevent default form action from being used
      e.preventDefault();
    });
  });
}
